/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query';
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import style from './ReportCardWidget.module.css';
import {
  useGetReportQuery,
  useGetReportTaskQuery,
} from '../../../../entities/reports/reportsResource/redux/reportsResource.api';
import Loading from '../../../../shared/ui/Loading/Loading';
import Error from '../../../../shared/ui/Error/Error';
import getErrorMessage from '../../../../shared/api/getErrorMessage';
import getErrorCode from '../../../../shared/api/getErrorCode';

import ScheduleReport from './components/ScheduleReport/ScheduleReport';
import DefaultReport from './components/DefaultReport/DefaultReport';
import { initControlsFields, initControlsFromReportTask } from './utils';
import { fileType } from './constants';

function ReportCardWidget({ companyId }) {
  const [searchParams] = useSearchParams();
  const reportId = parseInt(searchParams.get('report'), 10);
  const isSchedule = searchParams.get('schedule');
  const { reportTaskId } = useParams();

  const {
    data: reportTask,
    isLoading: isLoadingReportTask,
    isFetching: isFetchingReportTask,
  } = useGetReportTaskQuery(reportTaskId || skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const report = useGetReportQuery(reportId ? { id: reportId } : skipToken);

  const navigate = useNavigate();

  const [controls, setControls] = useState([]);
  const [selectedType, setSelectedType] = React.useState(fileType[0].value);

  useEffect(() => {
    if (!report?.data && !reportTask?.taskParams) return;

    const reportParams = reportTaskId
      ? initControlsFromReportTask(reportTask?.taskParams)
      : initControlsFields(report?.data?.reportParams);
    const fileFormat = reportTaskId ? reportTask?.reportFormat : fileType[0].value;
    setControls(reportParams);
    setSelectedType(fileFormat);
  }, [report?.data, reportTask]);

  if (report?.isLoading || isLoadingReportTask || isFetchingReportTask) {
    return <Loading />;
  }

  if (report?.isError) {
    const errorMessage =
      report?.error?.data?.errorMessage || getErrorMessage(getErrorCode(report?.error?.data?.status));
    return (
      <>
        <Error errorMessage={errorMessage} />
        <Box className={style.buttons}>
          <Button variant="contained" onClick={() => navigate(-1)}>
            Назад
          </Button>
        </Box>
      </>
    );
  }

  return isSchedule || reportTaskId ? (
    <ScheduleReport
      companyId={companyId}
      controls={controls}
      setControls={setControls}
      selectedType={selectedType}
      setSelectedType={setSelectedType}
      reportTask={reportTask}
      reportName={report?.data?.name}
    />
  ) : (
    <DefaultReport
      companyId={companyId}
      controls={controls}
      setControls={setControls}
      selectedType={selectedType}
      setSelectedType={setSelectedType}
    />
  );
}

export default ReportCardWidget;
